export default "__VITE_ASSET__v8X8ISAJ__"